import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Diseases A - Z',
    defaultMessage: 'Diseases A - Z',
  },
});
